import React from 'react';
import { Card } from 'antd';
import Line from 'components/Chart/LineChart';
import useCharts from 'customHooks/useCharts';
import { kpiVisualizationApi } from 'api/reports';
import ChartTitle from '../../../shared/ChartTitle';

function TransactionContributionMargin() {
  const { data, loading, startDate, endDate } = useCharts({ callApi: kpiVisualizationApi.getTransactionContributionMargin });

  return (
    <Card className="rounded-2xl">
      <ChartTitle title="Contribution Margin" startDate={startDate} endDate={endDate} />
      <Line
        data={data}
        dataKey="period"
        loading={loading}
        xLabel="Transaction Date"
        yLabel="Contribution Margin Amount"
        lines={[{ type: 'linear', dataKey: 'contribution_margin', stroke: '#009696', withLabelList: false }]}
        legendOptions={{ visible: true }}
      />
    </Card>
  );
}

export default TransactionContributionMargin;
